import {
  TOOLTIP_FONT_SIZE,
  TOOLTIP_GAP_BETWEEN_ICON_AND_TEXT,
  TOOLTIP_ICON_SIZE,
  TOOLTIP_MAX_WIDTH,
  TOOLTIP_MIN_WIDTH,
  TOOLTIP_PADDING,
} from './TooltipErrorsProps';

const CONTENT_MAX_WIDTH = TOOLTIP_MAX_WIDTH - TOOLTIP_PADDING;

export const measureTooltipWidth = (texts: string[]): number => {
  const container = document.createElement('div');
  Object.assign(container.style, {
    position: 'fixed',
    visibility: 'hidden',
    top: '-9999px',
    left: '-9999px',
    width: `${CONTENT_MAX_WIDTH}px`,
    fontSize: TOOLTIP_FONT_SIZE,
    fontWeight: '400',
    fontFamily: 'Inter, sans-serif',
    lineHeight: '17px',
    overflowWrap: 'break-word',
  });
  document.body.appendChild(container);

  const longestLine = texts.reduce((max, text) => {
    const span = document.createElement('span');
    span.textContent = text;

    container.style.whiteSpace = 'nowrap';
    container.replaceChildren(span);
    const singleLineWidth = span.getBoundingClientRect().width;

    if (singleLineWidth <= CONTENT_MAX_WIDTH) {
      container.style.whiteSpace = 'normal';
      return Math.max(max, singleLineWidth);
    }

    container.style.whiteSpace = 'normal';
    const range = document.createRange();
    range.selectNodeContents(span);
    const lineMax = Array.from(range.getClientRects()).reduce(
      (w, r) => Math.max(w, r.width),
      0
    );
    return Math.max(max, lineMax);
  }, 0);

  document.body.removeChild(container);

  const total =
    Math.ceil(longestLine) +
    TOOLTIP_PADDING +
    TOOLTIP_GAP_BETWEEN_ICON_AND_TEXT +
    TOOLTIP_ICON_SIZE;
  return Math.max(TOOLTIP_MIN_WIDTH, Math.min(total, TOOLTIP_MAX_WIDTH));
};
